export default class SimpleButton extends Phaser.GameObjects.Image {
  /**
   *  A simple prefab (extended game object class), displaying a spinning
   *  Phaser 3 logo.
   *
   *  @extends Phaser
   */
  constructor(scene, x, y, image, callback) {
    super(scene, x, y, image);
    this.name = image;
    this.blocked = false;
    this.btnSFX = 'click';
    scene.add.existing(this);
    this.setOrigin(0.5);
    this.emitter = new Phaser.Events.EventEmitter();
    this.setInteractive({
      useHandCursor: true
    }).on('pointerdown', () => { if (this.blocked === false) { this.onPress(scene, callback); } }, this);
  }

  onPress(scene, callback) {
    if (this.btnSfx !== undefined) {
      scene.sound.play(this.btnSFX);
    }
    this.animate(scene, callback);
  }

  animate(scene, callback) {
    let scX = this.scaleX;
    let scY = this.scaleY;
    if (this.pressTween != null) {
      this.pressTween.stop();
      this.pressTween = null;
    }
    this.pressTween = scene.tweens.add({
      targets: this,
      scaleX: scX * 0.9,
      scaleY: scY * 0.9,
      duration: 50,
      yoyo: true,
      onComplete: () => callback()
    });
  }

  destroy() {
    if (this.pressTween != null) {
      this.pressTween.stop();
      this.pressTween = null;
    }
    super.destroy();
  }
}
